import { ArrowLeftOnRectangleIcon, Cog6ToothIcon, CreditCardIcon, UserCircleIcon, UserGroupIcon, HomeIcon } from '@heroicons/react/24/outline'
import { Trans } from '@lingui/macro'
import React, { ElementType } from 'react'
import { Pages } from './routes.constant'
import { Role } from '@enums/role.enum'
import { User } from '@interfaces/user.interface'

export interface NavigationItem {
  key: string
  name: string | React.ReactNode
  href: string
  target?: string
  current: boolean
  icon?: ElementType
}

export const billingNavigation: NavigationItem[] = [
  { key: 'settings-billing-overview', name: <Trans>Overview</Trans>, href: Pages.BILLING_SETTINGS, current: false },
  { key: 'settings-billing-payment-methods', name: <Trans>Payment methods</Trans>, href: Pages.BILLING_PAYMENT_METHODS, current: false },
  { key: 'settings-billing-invoices', name: <Trans>Billing history</Trans>, href: Pages.BILLING_HISTORY, current: false },
]

export const settingsNavigation: NavigationItem[] = [
  { key: 'settings-general', name: <Trans>General</Trans>, href: Pages.SETTINGS, icon: UserCircleIcon, current: false },
  // { key: 'settings-security', name: <Trans>Security</Trans>, href: Pages.SECURITY_SETTINGS, icon: FingerPrintIcon, current: false },
  // { key: 'settings-notifications', name: <Trans>Notifications</Trans>, href: Pages.NOTIFICATIONS_SETTINGS, icon: BellIcon, current: false },
  // { key: 'settings-plan', name: <Trans>Plan</Trans>, href: Pages.PLAN_SETTINGS, icon: CubeIcon, current: false },
  { key: 'settings-billing', name: <Trans>Billing</Trans>, href: Pages.BILLING_SETTINGS, icon: CreditCardIcon, current: false },
  // { key: 'settings-integrations', name: <Trans>Integrations</Trans>, href: Pages.INTEGRATIONS_SETTINGS, icon: ArrowsRightLeftIcon, current: false },
  // { key: 'team-members', name: 'Team members', href: Pages.PLAN_SETTINGS, icon: UsersIcon, current: false },
]

export const navigation: NavigationItem[] = [
  { key: 'conversations', name: <Trans>Conversations</Trans>, href: Pages.HOME, current: true },
  { key: 'templates', name: <Trans>Templates</Trans>, href: Pages.TEMPLATES, current: false },
  { key: 'tags', name: <Trans>Tags</Trans>, href: Pages.TAGS, current: false },
]

export const getUserNavigation = (user: User | null): NavigationItem[] => [
  { key: 'settings', name: <Trans>Settings</Trans>, href: Pages.SETTINGS, icon: Cog6ToothIcon, current: false },
  ...(user?.role === Role.ADMIN ? [{ key: 'admin', name: <Trans>Admin</Trans>, href: Pages.ADMIN, icon: UserGroupIcon, current: false }] : []),
  { key: 'signout', name: <Trans>Logout</Trans>, href: Pages.TEMPLATES, icon: ArrowLeftOnRectangleIcon, current: false },
]

export const getAdminNavigation = (): NavigationItem[] => [
  { key: 'home', name: <Trans>Home</Trans>, href: Pages.HOME, icon: HomeIcon, current: false },
  { key: 'signout', name: <Trans>Logout</Trans>, href: Pages.TEMPLATES, icon: ArrowLeftOnRectangleIcon, current: false },
]

export const conversationTabs: NavigationItem[] = [
  { key: 'summary', name: <Trans>Summary</Trans>, href: '#', current: true },
  { key: 'settings', name: <Trans>Settings</Trans>, href: '#', current: false },
  { key: 'chat', name: <Trans>Chat</Trans>, href: '#', current: false },
]

export const mergedNavigations = [...navigation, ...getUserNavigation(null), settingsNavigation]
